// 普通装备
import { EquipMain } from "../equipmentType";
import { equipTypes } from "../equipConst";
import { propertyName, propertyAttr } from "@/const/character";
// 武器池
const equipPoolListW: EquipMain[] = [
  {
    name: "粗糙的铁剑",
    describe: "废铜烂铁罢了",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 10
      }
    ],
    grade: 0,
    level: 1,
    icon: 17,
    price: 3
  },
  {
    name: "还是粗糙的铁剑",
    describe: "废铜烂铁罢了",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 20
      }
    ],
    grade: 0,
    level: 5,
    icon: 1,
    price: 5
  },
  {
    name: "不太粗糙的铁剑",
    describe: "废铜烂铁罢了",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 40
      }
    ],
    grade: 0,
    level: 10,
    icon: 0,
    price: 10
  },
  {
    name: "铁剑",
    describe: "废铜烂铁罢了",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 60
      }
    ],
    grade: 0,
    level: 15,
    icon: 0,
    price: 20
  },
  {
    name: "破旧的帝国短剑",
    describe: "",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 120
      }
    ],
    grade: 0,
    level: 20,
    icon: 17,
    price: 50
  },
  {
    name: "折断的钢刃",
    describe: "没断之前一定是把好兵器，可是好兵器又怎么会断呢",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 140
      },
      {
        name: propertyName.AS,
        type: propertyAttr.AS,
        isPercent: false,
        value: 0.2
      }
    ],
    grade: 0,
    level: 24,
    icon: 1,
    price: 200
  }
];
// 防具池

const equipPoolListA: EquipMain[] = [
  {
    name: "粗糙的布衣",
    describe: "一块破布而已",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 10
      }
    ],
    grade: 0,
    level: 1,
    icon: 2,
    price: 3
  },
  {
    name: "普通的布衣",
    describe: "一块破布而已",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 30
      }
    ],
    grade: 0,
    level: 5,
    icon: 2,
    price: 5
  },
  {
    name: "精致的布衣",
    describe: "一块破布而已",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 70
      }
    ],
    grade: 0,
    level: 10,
    icon: 2,
    price: 10
  },
  {
    name: "还不错的布衣",
    describe: "一块破布而已",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 100
      }
    ],
    grade: 0,
    level: 15,
    icon: 2,
    price: 20
  },
  {
    name: "破旧的帝国盔甲",
    describe: "",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 100
      },
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: 350
      }
    ],
    grade: 0,
    level: 20,
    icon: 20,
    price: 70
  },
  {
    name: "破旧的野蛮人装甲",
    describe: "一股汗臭味",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 180
      },
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: 500
      }
    ],
    grade: 0,
    level: 25,
    icon: 37,
    price: 200
  }
];
// 首饰池
const equipPoolListJ: EquipMain[] = [
  {
    name: "破旧的草链",
    describe: "杂草做的项链",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: 30
      }
    ],
    grade: 0,
    level: 1,
    icon: 3,
    price: 3
  },
  {
    name: "脏脏的草链",
    describe: "杂草做的项链",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: 80
      }
    ],
    grade: 0,
    level: 5,
    icon: 3,
    price: 5
  },
  {
    name: "一般的草链",
    describe: "杂草做的项链",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: 160
      }
    ],
    grade: 0,
    level: 10,
    icon: 3,
    price: 10
  },
  {
    name: "还不错的草链",
    describe: "杂草做的项链",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: 300
      }
    ],
    grade: 0,
    level: 15,
    icon: 3,
    price: 20
  },
  {
    name: "粗糙的铁链",
    describe: "",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: 50
      }
    ],
    grade: 0,
    level: 19,
    icon: 15,
    price: 60
  },
  {
    name: "丢失的心意",
    describe: "不知是谁丢了它",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: 100
      }
    ],
    grade: 0,
    level: 23,
    icon: 22,
    price: 180
  }
];

const equipsGrade0: EquipMain[] = [
  ...equipPoolListW,
  ...equipPoolListA,
  ...equipPoolListJ
];
export { equipsGrade0 };
